import React from 'react';

export default function MenuLink(data) {

    var className = '';

    if (window.location.pathname.includes(data.item.folder)) {
        className = 'tabSideButton-active';
    }

    if (null != data.item.submenu) {
        return (
            <a className={'tabSideButton ' + className} href='javascript:void(0)'>{data.item.name}</a>
        );
    } else {
        return (
            <a className={'tabSideButton ' + className} href={data.item.url}>{data.item.name}</a>
        )
    }

}
